'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var formatters = {};
var genetiveMonths = ['siječnja', 'veljače', 'ožujka', 'travnja', 'svibnja', 'lipnja', 'srpnja', 'kolovoza', 'rujna', 'listopada', 'studenog', 'prosinca']; // Generate formatters like 'D MMMM',
// where month is in the genitive case: января, февраля, ..., декабря

var monthsGenitiveFormatters = ['D', 'Do', 'DD'];
monthsGenitiveFormatters.forEach(function (formatterToken) {
  formatters[formatterToken + ' MMMM'] = function (date, options) {
    var commonFormatters = options.formatters;
    var formatter = commonFormatters[formatterToken];
    return formatter(date, options) + ' ' + genetiveMonths[date.getUTCMonth()];
  };
});
exports.default = formatters;
module.exports = exports['default'];